import { skipToken, useQuery } from '@tanstack/react-query'
import { useConfig } from 'wagmi'

import { AccountConfig, SavingsAccountStats, SavingsStatsItem } from '@/config/chain/types'
import { SimplifiedQueryResult } from '@/domain/common/query'

export interface UseSavingsGeneralStatsParams {
  selectedAccountConfig: AccountConfig | undefined
  chainId: number
}

export interface UseSavingsGeneralStatsResult {
  queryResult: SimplifiedQueryResult<SavingsAccountStats>
  statsItems: SavingsStatsItem[]
}

export function useSavingsGeneralStats({
  selectedAccountConfig,
  chainId,
}: UseSavingsGeneralStatsParams): UseSavingsGeneralStatsResult {
  const wagmiConfig = useConfig()
  const queryOptions = selectedAccountConfig?.stats?.queryOptions?.({
    wagmiConfig,
    chainId,
  })
  const skipQueryOptions = {
    queryKey: ['skip'],
    queryFn: skipToken,
  } as const

  const statsItems = selectedAccountConfig?.stats?.items ?? []

  const queryResult = useQuery(queryOptions ?? skipQueryOptions)

  return {
    queryResult,
    statsItems,
  }
}
